<template>
  <div class="ly2" style="position:relative" v-show="contentShow" v-loading="loading" :element-loading-text="loadingText">
    <!-- <div class="ly2-left">
      <ChartLine :chartOption="this.chartOption1" height="520px" />
    </div>
    <div class="ly2-right">
      <GridLayout>
        <ChartLine :chartOption="this.chartOption2" height="260px" />
        <ChartLine :chartOption="this.chartOption3" height="260px" />
        <ChartLine :chartOption="this.chartOption4" height="260px" />
        <ChartLine :chartOption="this.chartOption5" height="260px" />
      </GridLayout>
    </div>-->
    <div class="search-form-group">
        <!-- <span class="redbox"></span> -->
        <span class="checkTitle">请选择时间段：</span>
        <el-date-picker
            v-model="rollingDate1"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateChange"
            placeholder="请选择开始时间">
          </el-date-picker>
          <span> 至 </span>
          <el-date-picker
            v-model="rollingDate2"
            style="margin-right: 10px"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择结束时间">
          </el-date-picker>
        <!-- <el-date-picker
            v-model="rollingDate"
            type="datetimerange"
            unlink-panels
            style="margin-left: 10px; margin-right: 10px"
            start-placeholder="请选择开始时间"
            range-separator="至"
            end-placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerDisabled">
        </el-date-picker> -->
        <el-button type="danger" @click="confirm" > &emsp;确认&emsp; </el-button>
        <el-button v-show="downloadExcelShow" class="download" type="warning" plain @click="downloadExcel" icon="el-icon-download">数据下载</el-button>
        <el-button v-show="!downloadExcelShow" class="download" type="warning" :loading="true" plain>下载..</el-button>
        <span class="moreTime" @mouseover="setMoreTimeShow">查看可选时间</span>
        <span class="notice"><span class="el-icon-info"></span>时间长度请勿超过1个小时哦~</span>
        <!-- <el-button type="danger" @click="getLegend" > &emsp;获取&emsp; </el-button> -->
        <span class="typeContent">
          <span class="typeItem" v-for="(item,index) in legendList" :key="index" @click="getLegend(index)">
            <span class="typeColor" :style="{background: typeList[index] == 0 ?colorList[index]:'#e1e1e1'}"></span>
            <span>{{item}}</span>
          </span>
        </span>
        <view style="clear:both"></view>
        <div class="timeCheckBox" v-if="moreTimeShow" @mouseleave ="setMoreTimeHid">
          <div class="timeCheck1" v-if="timeList.length == 0">无数据</div>
          <div class="timeCheck" v-for="(item,index) in timeList" :key="index" @click="setTime(item)">
              起始 {{item.startTime}} 结束 {{item.endTime}}
          </div>
        </div>
    </div>
    <div class="traceContent">
      <div class="lineItem">
        <div class="redB"></div>
        <div class="redBTitle">轨迹</div>
        <div class="lineItemf" id="trace"></div>
        <div class="noDateShow" v-if="rollingTraceData.pileDeviation==null||rollingTraceData.pileDeviation.length==0">暂无数据</div>
      </div>
    </div>
    <div class="lineContent">
      <div class="lineItem">
        <div class="redB"></div>
        <div class="redBTitle">速度(km/h)</div>
        <div class="lineItemf" id="speed"></div>
        <div class="noDateShow" v-if="rollingTraceData.speed==null||rollingTraceData.speed.length==0">暂无数据</div>
      </div>
      <div class="lineItem">
        <div class="redB"></div>
        <div class="redBTitle">温度(℃)</div>
        <div class="lineItemf" id="temperature"></div>
        <div class="noDateShow" v-if="rollingTraceData.temperature==null||rollingTraceData.temperature.length==0">暂无数据</div>
      </div>
    </div>
    <div class="lineContent" style="margin-top:6px">
      <div class="lineItem" v-if="false">
        <div class="lineItemf" id="deviation"></div>
        <div class="noDateShow" v-if="rollingTraceData.deviation==null||rollingTraceData.deviation.length==0">暂无数据</div>
      </div>
      <div class="lineItem">
        <div class="redB"></div>
        <div class="redBTitle">振动幅度(mm)</div>
        <div class="lineItemf" id="amplitude"></div>
        <div class="noDateShow" v-if="rollingTraceData.amplitude==null||rollingTraceData.amplitude.length==0">暂无数据</div>
      </div>
      <div class="lineItem">
        <div class="redB"></div>
        <div class="redBTitle">振动频率(Hz)</div>
        <div class="lineItemf" id="frequency"></div>
        <div class="noDateShow" v-if="rollingTraceData.frequency==null||rollingTraceData.frequency.length==0">暂无数据</div>
      </div>
    </div>
    <div style="clear:both"></div>
  </div>
</template>

<script>
import {rollingQualityTrace,exportExcelrollingTrace,getWorkTimeList} from "../../../../utils/api";
import {getDateSeconds1,getDateSecondsAfter,getDateSeconds,unique} from "../../../../utils/commons"
// import Rolling from "../../../../components/chart/rolling";
// import Compaction from "../../../../components/chart/compaction";
// import ChartLine from "../../../../components/chart/line";
// import GridLayout from "../../../../components/layout/grid";
export default {
  data() {
    return {
      leftData: [],
      chartOption1: {},
      chartOption2: {},
      chartOption3: {},
      chartOption4: {},
      chartOption5: {},
      contentShow: true,
      chart_1: "",
      chart_2: "",
      chart_3: "",
      // chart_4: "",
      chart_5: "",
      chart_6: "",
      setData: "",
      rollingTraceData:{
        amplitude:[{equipName:'',subDataMap:{}}],
        deviation:[{equipName:'',subDataMap:{}}],
        frequency:[{equipName:'',subDataMap:{}}],
        speed:[{equipName:'',subDataMap:{}}],
        temperature:[{equipName:'',subDataMap:{}}],
        trace:[{equipName:'',subDataMap:{}}]
      },
      rollingDate1:getDateSeconds1(),
      rollingDate2:getDateSecondsAfter(),
      loading:false,
      loadingText:'加载中..',
      timer:0, //定时器id
      moreTimeShow: false,
      timeList: [],
      legendList: [],
      typeList: [],
      colorList: ["#E96A5B", "#56BDFF","#5FDBA9","#F6C018","#FFA940"],
      downloadExcelShow: true,
    };
  },
  props: {
    activeIndex1Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
    workId: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    workName: {
      type: String,
      default: function () {
        return '';
      },
    },
  },
  // computed: {
  //   workId() {
  //     return this.$store.getters["quality/activeWorkId"];
  //   },
  // },
  created() {},
  mounted() {
    this.getTimeCheckListR()
    const echarts = require("echarts");
    this.chart_1 = echarts.init(document.getElementById("trace"));
    this.chart_2 = echarts.init(document.getElementById("speed"));
    this.chart_3 = echarts.init(document.getElementById("temperature"));
    // this.chart_4 = echarts.init(document.getElementById("deviation"));
    this.chart_5 = echarts.init(document.getElementById("amplitude"));
    this.chart_6 = echarts.init(document.getElementById("frequency"));
    this.getData();
    
  },
  watch: {
    activeIndex1Code: {
      handler(newVal) {
        //console.log(newVal);
        // setTimeout(function(){
        if (newVal == 3) {
          this.contentShow = true;
        } else {
          this.contentShow = false;
        }
        // },100)
      },
      deep: true,
      // immediate: true,
    },
    workId: {
      handler() {
        this.getTimeCheckListR()
        this.chart_1.clear();
        this.chart_2.clear();
        this.chart_3.clear();
        // this.chart_4.clear();
        this.chart_5.clear();
        this.chart_6.clear();
        
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    getLegend(data){
      console.log(data)
      this.loading=true;
      var selectArr = this.chart_1.getOption().legend[0].data;//legend所有值
      let obj = {}
      if(this.typeList[data] == 0){
        this.$set(this.typeList,data,1)
        obj[selectArr[data]] = false;
      }else{
        this.$set(this.typeList,data,0)
        obj[selectArr[data]] = true;
      }
      // this.$nextTick(()=>{
      setTimeout(()=>{
        this.chartOption1.legend.selected = obj;
        this.chart_1.setOption(this.chartOption1);
        this.chartOption2.legend.selected = obj;
        this.chart_2.setOption(this.chartOption2);
        this.chartOption3.legend.selected = obj;
        this.chart_3.setOption(this.chartOption3);
        this.chartOption5.legend.selected = obj;
        this.chart_5.setOption(this.chartOption5);
        this.chartOption6.legend.selected = obj;
        this.chart_6.setOption(this.chartOption6);
        this.loading=false
      },100)
        
      // })
      
      // this.loading=false
    },
    setMoreTimeShow(){
      this.moreTimeShow = true
    },
    setMoreTimeHid(){
      this.moreTimeShow = false
    },
    setTime(data){
      console.log(data)
      this.rollingDate1 = data.startTime
      this.rollingDate2 = data.endTime
      this.moreTimeShow = false
    },
    dateChange(val){
      let strtime=(val+'').replace(/-/g, '/');
      this.rollingDate2 = getDateSecondsAfter(strtime);
    },
    confirm(){
        if(this.rollingDate2<this.rollingDate1){
          this.$message({
            message: '结束时间大于开始时间，请重新选择！',
            type: 'warning'})
          return
        }
        this.getData();
    },
    getTimeCheckListR: function(){
        let params = {
            workId: this.workId,
            dataType: 2,
        }
        getWorkTimeList(params).then(res=>{
            console.log(res,'123')
            this.timeList = res.data.content.dataList
        })
    },
    async downloadExcel(){
        if(this.rollingDate2<this.rollingDate1){
          this.$message({
            message: '结束时间大于开始时间，请重新选择！',
            type: 'warning'})
          return
        }
        this.loadingText='下载中..'
        if(new Date(this.rollingDate2)-new Date(this.rollingDate1)>3600000){
          this.loadingText='时间跨度较长数据量可能较多，请耐心等待！'
        }
        this.loading=true;
        this.downloadExcelShow = false
        this.timer=setTimeout(()=>{this.loading=false;this.downloadExcelShow = true},60000)
        const InstructionManualvv = await exportExcelrollingTrace({workId: this.workId,startTime:this.rollingDate1,endTime:this.rollingDate2});
        if(!InstructionManualvv){
          this.loading=false
          this.downloadExcelShow = true
          clearTimeout(this.timer)
          return
        }
        let fileName = this.workName+'压实轨迹'+getDateSeconds()+'.xlsx';
        let blob = new Blob([InstructionManualvv.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});  
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href) //释放内存
        }
        this.loading=false
        this.downloadExcelShow = true
        clearTimeout(this.timer)
    },
    getData() {
      this.loadingText='加载中..'
      this.loading=true;
      this.timer=setTimeout(()=>{this.loading=false},60000)
      let params_trace = {
        workId: this.workId,
        startTime: this.rollingDate1,
        endTime: this.rollingDate2,
      }
      rollingQualityTrace(params_trace).then(res=>{
        this.rollingTraceData = res.data.content.info;
        // let minYData = res.data.content.info.minPile;
        // let minYData = 27500
        // let maxYData = res.data.content.info.maxPile;
        // let maxYData = 28000
        console.log(this.rollingTraceData,"this.rollingTraceData")
        let that = this
        let data=this.rollingTraceData;
        let legendList = []
        for(let i=0;i<data.amplitude.length;i++){
          legendList.push(data.amplitude[i].equipName)
          this.typeList.push(0)
        }
        this.legendList = legendList
        for (let key in data) {
          //console.log(key);
          if(key == 'pileDeviation'){
            let getArr = that.getSeriesP(data.pileDeviation);
            let xDataList = data.mileageList
            // let xData = getArr[0];
            let setSeries = getArr[0];
            that.chartOption1 = that.getOption_1("轨迹", setSeries,legendList, xDataList,'','');
            that.chart_1.clear();
            that.chart_1.setOption(that.chartOption1);
          }else if(key == 'speed'){
            let getArr = that.getSeries(data.speed);
            let xData = getArr[0];
            let setSeries = getArr[1];
            that.chartOption2 = that.getOption("速度(km/h)", setSeries, xData,legendList);
            that.chart_2.clear();
            that.chart_2.setOption(that.chartOption2);
          }else if(key == 'temperature'){
            let getArr = that.getSeries(data.temperature);
            let xData = getArr[0];
            let setSeries = getArr[1];
            that.chartOption3 = that.getOption("温度(℃)", setSeries, xData,legendList);
            that.chart_3.clear();
            that.chart_3.setOption(that.chartOption3);
          }else if(key == 'deviation'){
            // let getArr = that.getSeries(data.deviation);
            // let xData = getArr[0];
            // let setSeries = getArr[1];
            // let chartOption = that.getOption("偏移(m)", setSeries, xData);
            // that.chart_4.clear();
            // that.chart_4.setOption(chartOption);
          }else if(key == 'amplitude'){
            let getArr = that.getSeries(data.amplitude);
            let xData = getArr[0];
            let setSeries = getArr[1];
            that.chartOption5 = that.getOption("振动频率(Hz)", setSeries, xData,legendList);
            that.chart_5.clear();
            that.chart_5.setOption(that.chartOption5);
          }else if(key == 'frequency'){
            let getArr = that.getSeries(data.frequency);
            let xData = getArr[0];
            let setSeries = getArr[1];
            that.chartOption6 = that.getOption("振动幅度(mm)", setSeries, xData,legendList);
            that.chart_6.clear();
            that.chart_6.setOption(that.chartOption6);
          }
        }
        this.loading=false
        clearTimeout(this.timer)
      })
    },

    getSeries(data) {
      if(data==null||data.length==0){
        return [[],[]]
      }
      let series = [];
      // let xData = [];
      let resGet= [];
      data.map(item=>{
        resGet=resGet.concat(Object.keys(item.subDataMap))
      })
      resGet=unique(resGet).sort();
      // let resGet = data[0].subDataMap;
      // for (let key in resGet) {
      //   xData.push(key);
      // }
      // let getxAxisList = xData.sort();
      
      for (let i = 0; i < data.length; i++) {
        let yData = [];
        for (let j = 0; j < resGet.length; j++) {
          yData.push(data[i].subDataMap[resGet[j]]);
        }
        //console.log(yData)
        let setObj = {
          name: data[i].equipName,
          type: "line",
          data: yData,
        };
        series.push(setObj);
      }
      console.log([resGet, series],"[resGet, series]")
      return [resGet, series];
    },
    getSeriesP(data) {
      // if(data==null||data.length==0){
      //   return [[],[]]
      // }
      let series = [];
      for (let i = 0; i < data.length; i++) {
        // let yData = 
        //console.log(yData)
        let setObj = {
          name: data[i].equipName,
          type: "line",
          data: data[i].valueTimeList,
        };
        series.push(setObj);
      }
      return [series];
    },
    getOption_1(title, series,legendList,xData) {
      return Object.assign(
        {},
        {
          // title: { text: title },
          dataZoomEnd: Math.min(100, Math.ceil((8 / series.length) * 100)),
          legend: {
            data:legendList,
            bottom:1000
          },
          xAxis: [
            {
              type: "category",
              data: xData,
              splitArea: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "rgba(0,0,0,0.45)",
                },
                color: "rgba(0,0,0,0.45)",
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "",
              splitArea: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              // min: minV,
              // max: maxV,
              axisLabel: {
                lineStyle: {
                  color: "rgba(0,0,0,0.45)",
                },
                color: "rgba(0,0,0,0.45)",
                // formatter: function(value){
                  // console.log(value)
                  // let texts = []
                  // let getVal = ''
                  // if(value == 0){
                  //   getVal = 0
                  // }else if(value < 0){
                  //   getVal = 'K'+'00'+'+'+'0'
                  // }else if(value < 10){
                  //   getVal = 'K'+'00'+'+'+'00'+value
                  // }else if(value<100){
                  //   getVal = 'K'+'00'+'+'+'0'+value
                  // }else if(value<1000){
                  //   getVal = 'K'+'00'+'+'+value
                  // }else if(value<10000){
                  //   getVal = 'K0'+Math.floor(value/1000)+'+'+Math.ceil((value*1-(Math.floor(value/1000)*1000)))
                  // }else if(value<100000){
                  //   getVal = 'K'+Math.floor(value/1000)+'+'+Math.ceil((value*1-(Math.floor(value/1000)*1000)))
                  // }
                  // texts.push(getVal)
                  // return texts
                // }
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "10",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function(value){
              console.log(value)
              let str = ''
              for(let i=0;i<value.length;i++){
                str = str + '时间:' + value[i].data.time + '</br>'+'桩号:'+value[i].data.value[0] + '</br>'+'偏移:'+value[i].data.value[1] + '</br>'
              }
              
              return str
            }
          },
          grid: {
            bottom: 50,
            top: 60,
            left: 70,
            right: 20
          },
          color: this.colorList,
          series: series,
        }
      );
    },
    getOption(title, series, getxAxisList,legendList) {
      return Object.assign(
        {},
        {
          // title: { text: title },
          dataZoomEnd: Math.min(100, Math.ceil((8 / series.length) * 100)),
          legend: {
            data:legendList,
            bottom:1000
          },
          xAxis: [
            {
              type: "category",
              data: getxAxisList,
              splitArea: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "rgba(0,0,0,0.45)",
                },
                color: "rgba(0,0,0,0.45)",
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "",
              splitArea: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "rgba(0,0,0,0.45)",
                },
                color: "rgba(0,0,0,0.45)",
                // formatter: function(value){
                //   let texts = []
                //   let getVal = ''
                //   if(value < 10){
                //     getVal = 'K'+'00'+'+'+'00'+value
                //   }else if(value<100){
                //     getVal = 'K'+'00'+'+'+'0'+value
                //   }else if(value<=1000){
                //     getVal = 'K'+'00'+'+'+value
                //   }else if(value<=10000){
                //     getVal = 'K0'+Math.floor(value/1000)+'+'+(value-(Math.floor(value/1000)*1000))
                //   }else if(value<100000){
                //     getVal = 'K'+Math.floor(value/1000)+'+'+(value-(Math.floor(value/1000)*1000))
                //   }
                //   texts.push(getVal)
                //   return texts
                // }
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "10",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            bottom: 50,
            top: 60,
            left: 70,
            right: 20
          },
          color: this.colorList,
          series: series,
        }
      );
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped="">
.ly2 {
  width: 100%;
  height: 100%;
  display: block ;
  padding: 10px 0 30px 0;
}
.redB{
  width: 4px;
  height: 16px;
  background-color: #E96A5B;
  position: absolute;
  top: 28px;
  left: 24px;
}
.redBTitle{
  height: 24px;
  line-height: 24px;
  position: absolute;
  top: 24px;
  left: 36px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFang SC;
}
.traceContent{
  width: 50% !important;
  height: 95%;
  float: left;
  border: 1px solid #E8E8E8;
  display: flex;
  .lineItem {
    flex: 1;
    position: relative;
      border: 1px solid #E8E8E8;
    .lineItemf{
      height: 100%;
      width: 100%;
    }
    .noDateShow{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #ffffff, $alpha: 0.7);
      z-index: 100;
      text-align: center;
      line-height: 300px;
    }
  }
}
.lineContent {
  width: 50% !important;
  height: 47%;
  display: flex;
  float: left;
  
  .lineItem {
    flex: 1;
    position: relative;
    width: 49%;
    padding: 0 0px 0 10px;
    .lineItemf{
      height: 100%;
      width: 100%;
      border: 1px solid #E8E8E8;
    }
    .noDateShow{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #ffffff, $alpha: 0.7);
      z-index: 100;
      text-align: center;
      line-height: 300px;
    }
  }
  
}
.search-form-group {
    // margin-left: 10px;
    margin-top: 0px;
    margin-bottom: 10px;
    .typeContent{
      display: inline-block;
      height: 40px;
      // background-color: red;
      width: auto;
      float: right;
      .typeItem{
        height: 40px;
        line-height: 40px;
        display: inline-block;
        color: rgba(0,0,0,0.65);
        margin-left: 10px;
        font-size: 12px;
        cursor: pointer;
        .typeColor{
          display: inline-block;
          height: 10px;
          width: 10px;
          background-color: rosybrown;
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }
    .redbox{
        display: inline-block;
        width: 3px;
        height: 14px;
        background: red;
        line-height: 14px;
        margin-right: 5px;
    }
    .notice{
        color:#E96B5A;
        margin-left: 10px;
        font-size: 12px;
    }
    .timeCheckBox{
      position: absolute;
      width: 380px;
      height: auto;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      left: 750px;
      opacity: 1;
      z-index: 1000;
      padding: 12px;
      .timeCheck1{
        height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #777777;
          cursor: pointer;
          text-align: center;
      }
      .timeCheck{
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #777777;
          cursor: pointer;
      }
    }
    .moreTime{
        color:#777777;
        margin-left: 10px;
        font-size: 12px;
        cursor: pointer;
    }
    .checkTitle{
      font-size: 16px;
    }
  }
</style>